export default __webpack_public_path__ + "static/media/sc3.6fd5b14e.mp4";